import moment from 'moment'

const HET_PLANTS = [
  { value: '1', label: '深圳工厂' },
  { value: '2', label: '重庆工厂' },
  { value: '3', label: '苏州工厂' }
]

const VOICE_MODULES = [
  { id: '1', label: '客户质量' },
  { id: '2', label: '新产品开发质量' },
  { id: '3', label: '生产过程质量' },
  { id: '4', label: '供方质量' },
  { id: '5', label: '质量体系' }
]

const VOICE_LIST = [
  {
    id: 1001,
    title: '客户投诉闭环效率提升专项',
    module: '客户质量',
    cover: require('@/assets/img/app_new/CQRM.jpg'),
    releaseDate: '2026-02-12 10:00:00',
    content: '<p>本月客户投诉闭环平均周期从 7.2 天下降至 4.8 天。</p>'
  },
  {
    id: 1002,
    title: '新品导入阶段质量风险预警机制',
    module: '新产品开发质量',
    cover: require('@/assets/img/app_new/DFX.jpg'),
    releaseDate: '2026-02-18 09:30:00',
    content: '<p>新增 DVT 阶段周会审查机制，提前识别高风险失效模式。</p>'
  },
  {
    id: 1003,
    title: '制程不良率周度复盘机制上线',
    module: '生产过程质量',
    cover: require('@/assets/img/app_new/stop-line.jpg'),
    releaseDate: '2026-02-22 14:20:00',
    content: '<p>关键工站执行周度复盘，推动问题批次 48 小时内完成原因确认。</p>'
  },
  {
    id: 1004,
    title: '供应商来料一致性改善案例发布',
    module: '供方质量',
    cover: require('@/assets/img/app_new/supplier/SQM.jpg'),
    releaseDate: '2026-02-25 11:00:00',
    content: '<p>针对重点供应商批次波动，实施分层检验和首批加严方案。</p>'
  },
  {
    id: 1005,
    title: '体系审核问题项闭环通报（第一期）',
    module: '质量体系',
    cover: require('@/assets/img/app_new/quality-system/internal-audit.png'),
    releaseDate: '2026-03-02 08:45:00',
    content: '<p>内部审核问题项关闭率达到 96%，未关闭项已制定责任人和时间计划。</p>'
  },
  {
    id: 1006,
    title: '客户表扬案例月度分享',
    module: '客户质量',
    cover: require('@/assets/img/app_new/quality-system/quality-work-plan.png'),
    releaseDate: '2026-03-05 16:00:00',
    content: '<p>某关键客户对现场响应速度和问题复盘质量给予书面表扬。</p>'
  }
]

const USER_PROFILE = {
  id: 1,
  name: 'demo',
  postName: '质量管理部',
  jobNum: 'HET000001',
  email: 'demo.user@het.local',
  languageCode: 'zh'
}

const TODO_LIST = [
  { id: 1, title: '处理客户8D报告审批', status: 0, createdTime: '2026-03-09 09:20:00', url: '#/user' },
  { id: 2, title: '确认供应商来料异常闭环', status: 0, createdTime: '2026-03-08 14:10:00', url: '#/user' },
  { id: 3, title: '审核制程稽核整改措施', status: 0, createdTime: '2026-03-07 11:35:00', url: '#/user' },
  { id: 4, title: '发布月度质量复盘纪要', status: 1, createdTime: '2026-03-06 16:40:00', url: '#/user' },
  { id: 5, title: '更新客户投诉TOP问题看板', status: 1, createdTime: '2026-03-05 10:05:00', url: '#/user' },
  { id: 6, title: '跟进实验室失效分析报告', status: 0, createdTime: '2026-03-04 13:50:00', url: '#/user' },
  { id: 7, title: '评审新品导入风险清单', status: 1, createdTime: '2026-03-03 15:15:00', url: '#/user' },
  { id: 8, title: '核对质量成本月报数据', status: 0, createdTime: '2026-03-02 17:00:00', url: '#/user' }
]

const NOTIFICATION_LIST = [
  { id: 1, title: '质量月度通报（2026-03）', content: '本月重点关注客户投诉TOP3与闭环计划。', createTime: '2026-03-06 10:00:00' },
  { id: 2, title: '体系审核计划发布', content: '请各模块按计划完成内审自查。', createTime: '2026-03-05 14:30:00' },
  { id: 3, title: '供应商稽核结果公告', content: '重点供应商改善项请于本周内确认。', createTime: '2026-03-04 09:15:00' }
]

const FILE_CENTER_LIST = [
  { id: 1, name: '质量管理制度V3.2', path: 'https://example.com/mock-quality-policy.pdf', createTime: '2026-03-03 13:00:00' },
  { id: 2, name: '8D模板与填写说明', path: 'https://example.com/mock-8d-template.docx', createTime: '2026-03-02 16:40:00' },
  { id: 3, name: '供应商审核检查表', path: 'https://example.com/mock-supplier-checklist.xlsx', createTime: '2026-03-01 11:25:00' }
]

const SYS_ENTRY_HOME = [
  { id: 1, title: '质量看板', path: '/#/index' },
  { id: 2, title: '质量之声', path: '/#/list' },
  { id: 3, title: '个人中心', path: '/#/user' }
]

function resolveMonthList(createdTime) {
  if (!Array.isArray(createdTime) || createdTime.length < 2) {
    return []
  }

  const start = moment(createdTime[0], 'YYYY-MM')
  const end = moment(createdTime[1], 'YYYY-MM')
  const diffMonths = Math.abs(start.diff(end, 'months'))

  const months = []
  for (let i = 0; i < diffMonths; i += 1) {
    months.push(moment(createdTime[0], 'YYYY-MM').add(i, 'months').format('YYYY-MM'))
  }
  return months
}

function buildPlantSeries(createdTime, mapper) {
  const months = resolveMonthList(createdTime)
  const rows = []

  HET_PLANTS.forEach((plant, plantIndex) => {
    months.forEach((month, monthIndex) => {
      rows.push(mapper({ month, monthIndex, plantIndex }))
    })
  })

  return rows
}

function round2(value) {
  return Number(value.toFixed(2))
}

export function mockHetPlantDict() {
  return HET_PLANTS
}

export function mockModuleDict() {
  return VOICE_MODULES
}

export function mockCustomerDppmList(createdTime) {
  return buildPlantSeries(createdTime, ({ month, monthIndex, plantIndex }) => {
    const amountOfGoodsReceived = 12000 + plantIndex * 900 + monthIndex * 280
    const inspectionQty = 30 + plantIndex * 5 + monthIndex * 2
    return {
      month,
      amountOfGoodsReceived,
      inspectionQty,
      dppm: Math.round((inspectionQty * 1000000) / amountOfGoodsReceived),
      target: 3500
    }
  })
}

export function mockCustomerPassRatioList(createdTime) {
  return buildPlantSeries(createdTime, ({ month, monthIndex, plantIndex }) => {
    const auditQty = 80 + monthIndex * 3 + plantIndex * 5
    const passQty = auditQty - (4 + plantIndex)
    return {
      month,
      auditQty,
      passQty,
      passRate: round2((passQty * 100) / auditQty),
      target: 98.5
    }
  })
}

export function mockFailureTimesList(createdTime) {
  return buildPlantSeries(createdTime, ({ month, monthIndex, plantIndex }) => {
    const numberOfFail = Math.max(1, 13 - monthIndex - plantIndex)
    return {
      month,
      numberOfFail,
      target: 6
    }
  })
}

export function mockAppearanceDppmList(createdTime) {
  return buildPlantSeries(createdTime, ({ month, monthIndex, plantIndex }) => {
    const testNumber = 16000 + plantIndex * 1200 + monthIndex * 350
    const numberOfBadAppearance = 38 + plantIndex * 4 + monthIndex * 2
    return {
      month,
      testNumber,
      numberOfBadAppearance,
      ppm: Math.round((numberOfBadAppearance * 1000000) / testNumber),
      target: 2800
    }
  })
}

export function mockFunctionDppmList(createdTime) {
  return buildPlantSeries(createdTime, ({ month, monthIndex, plantIndex }) => {
    const testNumber = 17000 + plantIndex * 1300 + monthIndex * 320
    const numberOfDysfunc = 26 + plantIndex * 3 + monthIndex * 2
    return {
      month,
      testNumber,
      numberOfDysfunc,
      ppm: Math.round((numberOfDysfunc * 1000000) / testNumber),
      target: 2200
    }
  })
}

export function mockLarChartList(createdTime) {
  return buildPlantSeries(createdTime, ({ month, monthIndex, plantIndex }) => {
    const numberOfTestBatches = 350 + monthIndex * 10 + plantIndex * 18
    const numberOfBatchesReceived = numberOfTestBatches - (18 + plantIndex * 2)
    return {
      month,
      numberOfTestBatches,
      numberOfBatchesReceived,
      fpyOfIncomingBatch: round2((numberOfBatchesReceived * 100) / numberOfTestBatches),
      target: 95.0
    }
  })
}

export function mockDamageRatioList(createdTime) {
  return buildPlantSeries(createdTime, ({ month, monthIndex, plantIndex }) => {
    const outputValue = 9000 + monthIndex * 380 + plantIndex * 420
    const failureCost = 120 + monthIndex * 6 + plantIndex * 7
    return {
      month,
      outputValue,
      failureCost,
      qualityCostLossRate: round2((failureCost * 100) / outputValue),
      target: 1.8
    }
  })
}

export function mockCarouselList() {
  return [
    {
      name: '各工厂图片',
      pictures: [
        { title: '深圳工厂', path: require('@/assets/img/shenzhen.jpg') },
        { title: '苏州工厂', path: require('@/assets/img/suzhou.png') },
        { title: '重庆工厂', path: require('@/assets/img/chongqing.jpg') }
      ]
    }
  ]
}

export function mockVoiceList(moduleName, pageNum = 1, pageSize = 10000) {
  const filtered = !moduleName || moduleName === '全部'
    ? VOICE_LIST
    : VOICE_LIST.filter(item => item.module === moduleName)

  const start = (Number(pageNum) - 1) * Number(pageSize)
  const end = start + Number(pageSize)
  const paged = filtered.slice(start, end)

  return {
    list: paged,
    total: filtered.length
  }
}

export function mockVoiceItem(id) {
  const item = VOICE_LIST.find(v => Number(v.id) === Number(id))
  return item || VOICE_LIST[0]
}

export function mockCustomerList() {
  return [
    { id: '1', name: 'Apple' },
    { id: '2', name: 'Samsung' },
    { id: '3', name: 'Xiaomi' },
    { id: '4', name: 'OPPO' }
  ]
}

export function mockCustomerPlantList() {
  return [
    { value: '1', label: '客户A工厂' },
    { value: '2', label: '客户B工厂' },
    { value: '3', label: '客户C工厂' }
  ]
}

export function mockCustomerScoreData(monthList = []) {
  const tableData = []
  monthList.forEach((month, monthIndex) => {
    tableData.push({
      scoreDate: month,
      score: 87 + (monthIndex % 6),
      eightD: 90 + (monthIndex % 5),
      cal: 88 + (monthIndex % 4),
      dppm: 3200 - monthIndex * 90,
      hetFactoryIds: '1',
      customerId: '1',
      customerFactoryIds: '1'
    })
  })

  return {
    showMonth: monthList,
    data: tableData
  }
}

export function mockCustomerComplaintsData(monthList = []) {
  return monthList.map((month, index) => ({
    month,
    count: Math.max(1, 12 - index)
  }))
}

export function mockUserProfile() {
  return USER_PROFILE
}

export function mockRoleList() {
  return [
    { id: 1, name: '管理员' },
    { id: 2, name: '普通用户' }
  ]
}

export function mockTodoResponse(pageNum = 1, pageSize = 10, status, title) {
  const pNum = Number(pageNum) || 1
  const pSize = Number(pageSize) || 10
  const keyword = (title || '').trim()

  let filtered = TODO_LIST.slice()
  if (status === 0 || status === 1 || status === '0' || status === '1') {
    filtered = filtered.filter(item => Number(item.status) === Number(status))
  }
  if (keyword) {
    filtered = filtered.filter(item => item.title.indexOf(keyword) >= 0)
  }

  const start = (pNum - 1) * pSize
  const list = filtered.slice(start, start + pSize)

  const pending = TODO_LIST.filter(item => item.status === 0).length
  const processed = TODO_LIST.filter(item => item.status === 1).length

  return {
    pending,
    processed,
    rejected: 0,
    list: {
      list,
      total: filtered.length
    }
  }
}

export function mockNotificationList(pageNum = 1, pageSize = 10) {
  const pNum = Number(pageNum) || 1
  const pSize = Number(pageSize) || 10
  const start = (pNum - 1) * pSize
  const list = NOTIFICATION_LIST.slice(start, start + pSize)
  return {
    list,
    total: NOTIFICATION_LIST.length
  }
}

export function mockFileCenterList(pageNum = 1, pageSize = 10) {
  const pNum = Number(pageNum) || 1
  const pSize = Number(pageSize) || 10
  const start = (pNum - 1) * pSize
  const list = FILE_CENTER_LIST.slice(start, start + pSize)
  return {
    list,
    total: FILE_CENTER_LIST.length
  }
}

export function mockSysEntryList(appCode) {
  if (appCode === 'home') {
    return SYS_ENTRY_HOME
  }
  return []
}
